import { render, staticRenderFns } from "./DataListRisk.vue?vue&type=template&id=554f4d9a&scoped=true&"
import script from "./DataListRisk.vue?vue&type=script&lang=js&"
export * from "./DataListRisk.vue?vue&type=script&lang=js&"
import style0 from "./DataListRisk.vue?vue&type=style&index=0&id=554f4d9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f4d9a",
  null
  
)

export default component.exports